<template>
  <b-form-select
    v-model="selectedId"
    :options="options"
    :state="state"
    :disabled="loading"
  >
    <template #first>
      <b-form-select-option :value="null" disabled>
        {{ loading ? 'Carregando...' : 'Selecione um responsável' }}
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    value: {
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
    placeholder: {
      type: String,
      default: "Selecione um responsável",
    },
  },
  data: () => ({
    selectedId: null,
    responsibles: [],
    loading: false,
  }),
  computed: {
    options() {
      return this.responsibles.map((r) => ({
        value: r.id,
        text: r.name,
      }));
    },
  },
  methods: {
    ...mapActions("physical_people", ["ActionFind", "ActionFindById"]),
    async loadAll() {
      this.loading = true;
      try {
        const result = await this.ActionFind("");
        let list = result || [];
        const selectedId = this.value ? Number(this.value) : null;
        if (selectedId && !list.some((r) => r.id === selectedId)) {
          const person = await this.ActionFindById(selectedId);
          if (person && person.id) {
            list = [person, ...list];
          }
        }
        this.responsibles = list;
      } catch (e) {
        this.responsibles = [];
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    selectedId(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.selectedId = val;
    },
  },
  async created() {
    this.selectedId = this.value || null;
    await this.loadAll();
  },
};
</script>
